
import { ButtonHTMLAttributes, ReactNode } from 'react';

interface ButtonProps extends ButtonHTMLAttributes<HTMLButtonElement> {
  variant?: 'primary' | 'secondary' | 'outline' | 'ghost';
  size?: 'sm' | 'md' | 'lg';
  children: ReactNode;
  fullWidth?: boolean;
}

export default function Button({ 
  variant = 'primary', 
  size = 'md', 
  children, 
  fullWidth = false,
  className = '',
  ...props 
}: ButtonProps) {
  const baseClasses = 'font-medium rounded-lg transition-all duration-200 cursor-pointer whitespace-nowrap flex items-center justify-center gap-2';
  
  const variants = {
    primary: 'bg-[#22577A] hover:bg-[#1a4460] text-white shadow-lg hover:shadow-xl',
    secondary: 'bg-[#38a3a5] hover:bg-[#2d8285] text-white shadow-lg hover:shadow-xl',
    outline: 'border-2 border-[#22577A] text-[#22577A] hover:bg-[#22577A] hover:text-white',
    ghost: 'text-[#22577A] hover:bg-[#e4f4ff]/20'
  };
  
  const sizes = {
    sm: 'px-4 py-2 text-sm',
    md: 'px-6 py-3 text-base',
    lg: 'px-8 py-4 text-lg'
  };
  
  const widthClass = fullWidth ? 'w-full' : '';
  
  return (
    <button 
      className={`${baseClasses} ${variants[variant]} ${sizes[size]} ${widthClass} ${className}`}
      {...props}
    >
      {children}
    </button>
  );
}
